export function pushOpenUpliftModalEvent() {
  const evt = new CustomEvent('openUpliftModalEvent');
  window.dispatchEvent(evt);
}
